import { LicenseManager } from 'ag-grid-enterprise';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';

ModuleRegistry.registerModules([AllCommunityModule]);

// Dynamic import defers loading the bundle until the browser has finished
// parsing, avoiding a race between custom-element registration and first
// render — required for the Web Component / Module Federation bootstrap.
import('./bootstrap').catch((err) => console.error(err));

LicenseManager.setLicenseKey("CompanyName=Amrut Software Private Limited_on_behalf_of_ANALYTICS QUOTIENT - INDIA,LicensedApplication=Olympus,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-027212,ExpiryDate=1_April_2023_[v2]_MTY4MDMwMzYwMDAwMA==390582b04422a48347c898f322c3cbd4");